(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["default-collection-grid-2026"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Sort dropdown (normal grid mode).
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-dcg-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // Hub-mode rails: prev/next scroll one card width; disable arrows at the ends.
  function initGroup(group) {
    var track = group.querySelector('[data-track]');
    var prev = group.querySelector('[data-prev]');
    var next = group.querySelector('[data-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.dcg-2026__card');
      return card ? Math.round(card.getBoundingClientRect().width) : Math.round(track.clientWidth * 0.8);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var groups = document.querySelectorAll('.dcg-2026__group');
    for (var i = 0; i < groups.length; i++) initGroup(groups[i]);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2026"]) return;
  try {
    
(function () {
  function initHeader() {
    var header = document.querySelector('[data-al-header]');
    if (!header || header.dataset.alInit === 'true') return;
    header.dataset.alInit = 'true';

    // Sticky CTA bar reveals once scrolled past the main header
    var sticky = document.querySelector('[data-al-sticky]');
    if (sticky) {
      var onScroll = function () {
        var show = window.scrollY > 120;
        sticky.classList.toggle('is-visible', show);
        // Keep the off-screen clone out of the tab order + a11y tree until it's on screen
        sticky.inert = !show;
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var megaItems = Array.prototype.slice.call(header.querySelectorAll('[data-al-mega]'));
    var closeTimer;

    function closeAll(except) {
      megaItems.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var t = item.querySelector('[data-al-mega-trigger]');
        var p = item.querySelector('[data-al-mega-panel]');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (p) p.hidden = true;
      });
      if (!except) header.classList.remove('al-header--panel-open');
    }

    function open(item) {
      clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      var t = item.querySelector('[data-al-mega-trigger]');
      var p = item.querySelector('[data-al-mega-panel]');
      if (t) t.setAttribute('aria-expanded', 'true');
      if (p) p.hidden = false;
      header.classList.add('al-header--panel-open');
    }

    function close(item) {
      item.classList.remove('is-open');
      var t = item.querySelector('[data-al-mega-trigger]');
      var p = item.querySelector('[data-al-mega-panel]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
      header.classList.remove('al-header--panel-open');
    }

    megaItems.forEach(function (item) {
      var trigger = item.querySelector('[data-al-mega-trigger]');
      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 990px)').matches) open(item);
      });
      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(min-width: 990px)').matches) {
          closeTimer = setTimeout(function () { close(item); }, 120);
        }
      });
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.classList.contains('is-open')) { close(item); } else { open(item); }
        });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); closeSearch(); closeMobile(); }
    });
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });

    // Inline search (toggled from the main header and the sticky bar)
    var searchToggles = Array.prototype.slice.call(document.querySelectorAll('[data-al-search-toggle]'));
    var searchBar = document.querySelector('[data-al-search]');
    var searchClose = document.querySelector('[data-al-search-close]');
    var searchInput = document.querySelector('[data-al-search-input]');

    function setSearchExpanded(state) {
      searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', String(state)); });
    }
    function openSearch() {
      if (!searchBar) return;
      closeAll();
      searchBar.hidden = false;
      setSearchExpanded(true);
      if (searchInput) searchInput.focus();
    }
    function closeSearch() {
      if (!searchBar) return;
      searchBar.hidden = true;
      setSearchExpanded(false);
    }
    searchToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (searchBar && searchBar.hidden) { openSearch(); } else { closeSearch(); }
      });
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    // Mobile drawer (a burger lives in both the main header and the sticky bar)
    var burgers = Array.prototype.slice.call(document.querySelectorAll('[data-al-burger]'));
    var mobile = document.querySelector('[data-al-mobile]');

    function setBurgerExpanded(state) {
      burgers.forEach(function (b) { b.setAttribute('aria-expanded', String(state)); });
    }
    function openMobile() {
      if (!mobile) return;
      mobile.hidden = false;
      setBurgerExpanded(true);
      document.body.classList.add('al-no-scroll');
    }
    function closeMobile() {
      if (!mobile) return;
      mobile.hidden = true;
      setBurgerExpanded(false);
      document.body.classList.remove('al-no-scroll');
    }
    burgers.forEach(function (burger) {
      burger.addEventListener('click', function () {
        if (mobile && mobile.hidden) { openMobile(); } else { closeMobile(); }
      });
    });
    if (mobile) {
      mobile.querySelectorAll('[data-al-mobile-close]').forEach(function (el) {
        el.addEventListener('click', closeMobile);
      });
      mobile.querySelectorAll('[data-al-mobile-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.al-mobile__item') || btn.parentNode;
          var sub = item.querySelector('[data-al-mobile-sub]');
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          if (sub) sub.hidden = expanded;
        });
      });
    }
  }

  if (document.readyState !== 'loading') { initHeader(); }
  else { document.addEventListener('DOMContentLoaded', initHeader); }
  document.addEventListener('shopify:section:load', initHeader);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-2026"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.partnersInit === 'true') return;
    var track = root.querySelector('[data-partners-track]');
    if (!track) return;
    root.dataset.partnersInit = 'true';

    // Controls (arrows + dots) are optional — drag/swipe works without them.
    var controls = root.querySelector('[data-partners-controls]');
    var prev = controls && controls.querySelector('[data-partners-prev]');
    var next = controls && controls.querySelector('[data-partners-next]');
    var dotsWrap = controls && controls.querySelector('[data-partners-dots]');
    var dots = [];

    function pageCount() {
      // round to the nearest page so a tiny sub-pixel remainder doesn't add a ghost page
      return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
    }
    function currentPage() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function buildDots() {
      if (!dotsWrap) return;
      var pages = pageCount();
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'partners-2026__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function update() {
      if (!controls) return;
      var hasOverflow = track.scrollWidth - track.clientWidth > 2;
      controls.hidden = !hasOverflow;
      if (!hasOverflow) return;

      var page = currentPage();
      var pages = pageCount();
      if (dots.length !== pages) buildDots();
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-selected', i === page ? 'true' : 'false');
      }
      if (prev) prev.disabled = page <= 0;
      if (next) next.disabled = page >= pages - 1;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });

    // Pointer drag (mouse). Touch uses native momentum scrolling.
    var down = false, startX = 0, startScroll = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setAttribute('data-dragging', 'true');
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      track.removeAttribute('data-dragging');
      update();
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    // swallow the click that follows a real drag so links don't fire
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    buildDots();
    update();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { buildDots(); update(); }, 150);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-partners]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: (re)init when this section is loaded/reordered.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-partners]');
    if (root) { root.dataset.partnersInit = ''; initCarousel(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-collection-grid-2026"]) return;
  try {
    
(function () {
  function initGroup(group) {
    var track = group.querySelector('[data-track]');
    var prev = group.querySelector('[data-prev]');
    var next = group.querySelector('[data-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.sale-grid-2026__card');
      return card ? Math.round(card.getBoundingClientRect().width) : Math.round(track.clientWidth * 0.8);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var groups = document.querySelectorAll('.sale-grid-2026__group');
    for (var i = 0; i < groups.length; i++) initGroup(groups[i]);

    var select = document.getElementById('prodcutType');
    if (select) {
      select.addEventListener('change', function () {
        if (this.value) swapTo(this.value);
      });
    }
  }

  /* AJAX type switch (Section Rendering API): swap hero + grid in place, keep URL/history sane. */
  var HERO_CLASS = 'shopify-section--inner-hero-2026';
  function sectionWrap(innerSelector, sectionClass) {
    var el = sectionClass ? document.querySelector('.' + sectionClass) : document.querySelector(innerSelector);
    if (el && !/^shopify-section-/.test(el.id || '')) el = el.closest('[id^="shopify-section-"]');
    return el;
  }
  function swapTo(url) {
    var gridWrap = sectionWrap('.sale-grid-2026', 'shopify-section--sale-grid-2026');
    var heroWrap = HERO_CLASS ? sectionWrap(null, HERO_CLASS) : null;
    if (!gridWrap) { window.location.href = url; return; }
    var ids = [gridWrap.id.replace('shopify-section-', '')];
    if (heroWrap) ids.push(heroWrap.id.replace('shopify-section-', ''));
    gridWrap.style.opacity = '0.35';
    gridWrap.style.transition = 'opacity .2s';
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=' + ids.join(','))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (map) {
        var gridHtml = map[ids[0]];
        if (!gridHtml) throw new Error('no section');
        var heroHtml = heroWrap ? map[ids[1]] : null;
        /* Preload incoming images (hero bg + first cards) so nothing paints blank mid-swap */
        var probe = document.createElement('div');
        probe.innerHTML = (heroHtml || '') + gridHtml;
        var urls = [];
        probe.querySelectorAll('img').forEach(function (im) {
          var src = im.currentSrc || im.src || (im.getAttribute('srcset') || '').split(' ')[0];
          if (src && urls.length < 8) urls.push(src);
        });
        var preload = urls.map(function (s) {
          return new Promise(function (res) { var i = new Image(); i.onload = i.onerror = res; i.src = s; });
        });
        return Promise.race([Promise.all(preload), new Promise(function (res) { setTimeout(res, 900); })])
          .then(function () {
            function swapIn(wrap, html) {
              var tmp = document.createElement('div');
              tmp.innerHTML = html;
              var node = tmp.firstElementChild;
              if (!node) return null;
              node.style.opacity = '0';
              node.style.transition = 'opacity .28s ease';
              wrap.replaceWith(node);
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  node.style.opacity = '1';
                  setTimeout(function () { node.style.opacity = ''; node.style.transition = ''; }, 400);
                });
              });
              return node;
            }
            if (heroWrap && heroHtml) swapIn(heroWrap, heroHtml);
            swapIn(gridWrap, gridHtml);
            history.pushState({ alTypeSwap: true }, '', url);
            init();
          });
      })
      .catch(function () { window.location.href = url; });
  }
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.alTypeSwap) { window.location.reload(); }
    else if (history.state === null && document.getElementById('prodcutType')) { window.location.reload(); }
  });

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-2026"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTestimonials(root) {
    if (!root || root.dataset.tInit === '1') return;
    root.dataset.tInit = '1';

    var viewport = root.querySelector('[data-viewport]');
    var track = root.querySelector('[data-track]');
    var nav = root.querySelector('[data-nav]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!track || !nav || !prev || !next) return;

    function pageAmount() {
      // Page by the visible width so it advances a full "view" (2 cards desktop, 1 mobile).
      var card = track.querySelector('[data-card]');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var step = card.getBoundingClientRect().width + gap;
      // Snap the page to a whole number of cards that fit the viewport.
      var perView = Math.max(1, Math.round((track.clientWidth + gap) / step));
      return step * perView;
    }

    function canScroll() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    function update() {
      if (!canScroll()) {
        nav.setAttribute('hidden', '');
        return;
      }
      nav.removeAttribute('hidden');
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -pageAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: pageAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(update);
    });

    update();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-testimonials]');
    for (var i = 0; i < roots.length; i++) initTestimonials(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-init the affected section.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
